import { useState, useEffect } from 'react';
import { FloorPlan } from '@/types/floorPlanViewer';

interface UseFloorPlanSetupReturn {
  isReady: boolean;
  error: Error | null;
}

export function useFloorPlanSetup(floorPlan: FloorPlan): UseFloorPlanSetupReturn {
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    // Basic validation
    if (!floorPlan?.id) {
      setError(new Error('Invalid floor plan'));
      return;
    }

    // Simulate any setup needed
    // In the future, this could preload images, etc.
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 100);

    return () => clearTimeout(timer);
  }, [floorPlan]);

  return { isReady, error };
}
